import { DTO } from "@equidefi/shared/types";
import { ApiClient } from "./ApiClient";

type StartParams = {
  investment_id: string;
  citizenship: "US_CITIZEN" | "INTERNATIONAL";
};

class InquiryClient extends ApiClient {
  async start(
    investmentId: string,
    userId: string,
    entityType: string,
    citizenship: string,
    inquiryType: string,
    options?: Record<string, any>,
  ) {
    const response = await this.post(`/v2/inquiries/start/${investmentId}`, {
      userId,
      entityType,
      citizenship,
      inquiryType,
      options,
    });
    return response.data;
  }
  async find(inquiryId: string) {
    const response = await this.get(`/v2/inquiries/${inquiryId}`);
    return response.data;
  }

  async getFull(inquiryId: string, data: { investmentId: string; entityType: string; citizenship: string }) {
    const response = await this.post(`/v2/inquiries/details/${inquiryId}`, data);
    return response.data;
  }

  async print(inquiryId: string) {
    const response = await this.get(`/v2/inquiries/${inquiryId}/print`, {
      responseType: "arraybuffer",
    });

    return response.data;
  }

  async resume(inquiryId: string, data: Record<string, string>) {
    const response = await this.post(`/v2/inquiries/resume/${inquiryId}`, data);

    return response.data;
  }

  async getInvestmentInquiries(investmentId: string, params?: object) {
    const response = await this.get(`/v2/inquiries/list/${investmentId}`, {
      params,
    });

    return response.data;
  }

  async emailInvestor(inquiryId: string, investmentId: string, data: Record<string, string>) {
    const response = await this.post(`/v2/inquiries/email/${investmentId}/${inquiryId}`, data);

    return response.data;
  }

  async remove(inquiryId: string) {
    await this.delete(`/v2/inquiries/${inquiryId}`);
  }

  async approve(investmentId: string, inquiryId: string, data: Record<string, any>) {
    const response = await this.post(`/v2/inquiries/approve/${investmentId}/${inquiryId}`, data);
    return response.data;
  }

  async decline(investmentId: string, inquiryId: string, data: Record<string, any>) {
    const response = await this.post(`/v2/inquiries/decline/${investmentId}/${inquiryId}`, data);
    return response.data;
  }

  async runReports(investmentId: string, inquiryId: string) {
    const response = await this.post(`/v2/inquiries/reports/${investmentId}/${inquiryId}`);
    return response.data;
  }

  async resetInquiry(
    investmentId: string,
    inquiryId: string,
    payload: {
      citizenship: DTO.Vault["citizenship"];
      inquiryType: "KYC" | "KYB";
      userId: string;
    },
  ) {
    const response = await this.put(`/v2/inquiries/reset/${investmentId}/${inquiryId}`, payload);
    return response.data;
  }

  async getVerifications(inquiryId: string, investmentId: string): Promise<DTO.PersonaVerifications> {
    const response = await this.get(`/v2/inquiries/verifications/${investmentId}/${inquiryId}`);
    return response.data;
  }
}

export default InquiryClient;
